// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import animateScrollTo from "animated-scroll-to";
import {
  breakpoints,
  expandValue,
  transition,
  sizes,
  typeSet
} from "../../helpers/theme";

let TopStyles = props => css`
  width: 60%;
  height: 60%;
  padding-top: ${expandValue(sizes.space * 0.4)};
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  ${typeSet(sizes.fontSize * 0.5)}
  font-weight: 300;
  cursor: pointer;
  ${transition("all", sizes.timer + "ms")}
  border-radius: 50%;
  .icon {
    ${transition("transform", sizes.timer + "ms")}
    position: absolute;
    top: 20%;
    right: 25%;
    bottom: 30%;
    left: 25%;
    svg {
      display: block;
    }
    .st0 {
      ${transition("stroke", sizes.timer + "ms")}
    }
  }
  &:hover .icon {
    transform: translateY(-20%);
  }
  @media (min-width: ${expandValue(breakpoints[3])}) {
    width: 60%;
    height: 60%;
    ${typeSet(sizes.fontSize * 0.75)}
    .icon {
      top: 25%;
      right: 25%;
      bottom: 25%;
      left: 25%;
    }
  }
`;
let TopStyled = styled("div")`
  ${TopStyles}
`;

export class Top extends React.Component {
  scrollToTop() {
    animateScrollTo(0);
  }

  render() {
    return (
      <TopStyled
        className="top-floor"
        onClick={() => {
          this.scrollToTop();
        }}
      >
        TOP
        <div className="icon">
          <svg viewBox="0 0 48 48" width="100%">
            <polyline
              points="43,15.3 24,4.3 5,15.3"
              fill="none"
              className="st0"
              vectorEffect="non-scaling-stroke"
              strokeMiterlimit={10}
            />
          </svg>
        </div>
      </TopStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Top.js